export const FK_SYMBOL = "→";
